import React from 'react';
import img from '../images/yamin.jpg'
import { Typewriter } from 'react-simple-typewriter';

const Hero = () => {
    return (
        <div>
           <div className='flex h-screen flex-col md:flex-row justify-center items-center bg-[#f5f7ff]'>
                <div className="md:w-3/5 flex flex-col justify-center items-start mx-10" >
                    <h2 className='text-4xl mt-2 lg:mt-0 text-[#fca311] drop-shadow-2xl font-bold' 
                    data-aos="fade-right"
                    data-aos-duration="1100"
                    data-aos-easing="ease-out-left"
                    data-aos-mirror="true"
                    > HEY THERE! </h2>
                    <h1 className='text-4xl text-[#14213d] drop-shadow-2xl font-bold'
                    data-aos="fade-right"
                    data-aos-duration="1100"
                    data-aos-easing="ease-out-left"
                    data-aos-mirror="true"
                    >I'M {' '}
                    
                    <span style={{ color: '#14213d', fontWeight: 'bold' }}>
          {/* Style will be inherited from the parent element */}
          <Typewriter
            words={['YAMIN ARAFAT',  'A MERN STACK Web Developer']}
            loop={true}
            cursor
            cursorStyle='_'
            typeSpeed={150}
            deleteSpeed={100}
            delaySpeed={1000}
          />
        </span>
                    </h1>
                    
                    <p className='text-lg md:w-2/3 text-justify '
                    data-aos="fade-right"
                    data-aos-duration="1200"
                    data-aos-easing="ease-out-left"
                    data-aos-mirror="true">I'm a passionate Jr. Web Developer. I'm also a curious Web Developer who wants to learn new technologies every moment. My hobby is programming. </p>
                    <div className="flex gap-2 mt-2"
                    data-aos="fade-right"
                    data-aos-duration="1300"
                    data-aos-easing="ease-out-left"
                    data-aos-mirror="true"
                    >
                    <a href="https://drive.google.com/file/d/1Maesmv6btRVsBVpW_qv5qb2h9_CkRvrM/view?usp=sharing" className='btn bg-violet-600 hover:bg-violet-700 border-0 rounded-full'>MY RESUME</a>
                    <a href="https://www.linkedin.com/in/yamin-arafat-71029818a/" className='btn bg-violet-600 hover:bg-violet-700 border-0 rounded-full'>LinkedIn</a>
                    </div>
                </div>
                <div className="w-[300px] h-[300px] my-12 " 
                data-aos="fade-left"
                data-aos-duration="1300"
                data-aos-easing="ease-out-left"
                data-aos-mirror="true"

>
                    <img src={img} alt="" className='rounded-full w-full h-full  overflow-hidden' />
                </div>
            </div> 
        </div>
    );
};

export default Hero;